export default "__VITE_ASSET__ISiSvUls__"